export default __webpack_public_path__ + "static/media/a009-ransomware-03.c4ebdb5d.svg";